import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { apiFetch } from "../utils/api";
import { useAuth, refreshUser } from "../AuthContext";

/* ##### Explanation ####
Gets session_id from the URL after Stripe redirect.
Calls /verify-subscription endpoint with JWT token.
Updates the user plan in the backend and shows confirmation.
Optionally redirects to the dashboard after a few seconds.
*/

export default function SubscriptionSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  const [message, setMessage] = useState("Verifying your subscription...");
  const { setUser, refreshUser } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const session_id = params.get("session_id");
    if (!session_id) {
      setMessage("No session found.");
      return;
    }

    const verify = async () => {
      try {
        const res = await apiFetch(`/verify-subscription?session_id=${session_id}`);
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail || "Verification failed");
        setMessage(data.message);

        // Update local user state after subscription verified
        setUser(prev => ({
          ...prev,
          plan: data.plan, // e.g., "basic" or "pro"
          is_active: data.is_active,
        }));

        // Refresh user from backend to make sure dashboard sees updated plan
        await refreshUser();

        // Optional: Redirect to dashboard after 3 seconds
        // setTimeout(() => navigate("/dashboard_recruiter"), 3000);
        navigate("/dashboard_recruiter");
      } catch (err) {
        console.error(err);
        setMessage("Subscription verification failed.");
      }
    };

    verify();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-6">
      <div className="bg-white p-12 rounded-2xl shadow text-center max-w-xl">
        <h1 className="text-3xl font-bold mb-4">Subscription Status</h1>
        <p className="text-gray-700">{message}</p>
      </div>
    </div>
  );
}
